import { ReactNode } from "react";
import "./index.css";

/**
 * The tints a bubble comes in (the person pages' Details card): green for a
 * person or a phone, sky for email or a repeat, orange for a date, indigo
 * for an address or a place. The section titles add teal and violet, so no
 * two sections on a tab share a tint. Red marks a delete in a menu.
 */
export enum BubbleTone {
  GREEN = "green",
  SKY = "sky",
  ORANGE = "orange",
  INDIGO = "indigo",
  TEAL = "teal",
  VIOLET = "violet",
  RED = "red",
}

/**
 * A small icon in a tinted round bubble, labeling a row: 34px with a 15px
 * icon, or 26px with a 13px icon for compact rows. Decorative: the row's
 * text says what it is.
 */
export default function IconBubble({
  tone,
  small = false,
  children,
}: {
  tone: BubbleTone;
  small?: boolean;
  children: ReactNode;
}) {
  return (
    <span
      className={`icon-bubble icon-bubble--${tone}${
        small ? " icon-bubble--small" : ""
      }`}
      aria-hidden
    >
      {children}
    </span>
  );
}
